module.exports = __webpack_public_path__ + "static/media/defaultAvatar.2500e24c.svg";